import * as React from 'react'

import { cn } from '@lib/utils'

const Input = ({
  className,
  type,
  ...props
}: React.ComponentProps<'input'>) => (
  <input
    data-slot='input'
    type={type}
    className={cn(
      'flex h-14 w-full rounded-none border border-input bg-background px-3 py-2 text-xl ring-offset-background file:border-0 file:bg-transparent file:text-xl file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
)
Input.displayName = 'Input'

export { Input }
